import React, { FC, useEffect, useState, useRef, MutableRefObject } from "react";
// libs
import NextImage from "next/image";
// components
import Link from "src/components/ui/Link";
// utils
import { formatSearchUrl } from "src/utils/url";
// theme
import {
  Wrapper,
  Content,
  Text,
  ImageContainer,
  NextImageWrapper,
  ListWrapper,
  ListItem,
} from "./styles";
import { Action, Callout } from "src/theme/typography";
import { colors } from "src/theme";

interface IDropdownAnimated {
  state: string;
  city: string;
  areas: string[];
}

const DropdownAnimated: FC<IDropdownAnimated> = ({ state, city, areas }) => {
  const dropdown: MutableRefObject<HTMLDivElement | null> = useRef(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleState = () => setIsOpen(!isOpen);

  const closeDropdown = (e: MouseEvent) => {
    setIsOpen(false);
    e?.stopPropagation();
  };

  const handleClickDropdownOutside = (event: MouseEvent): void => {
    if (!dropdown.current?.contains(event.target as HTMLDivElement)) {
      closeDropdown(event);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickDropdownOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickDropdownOutside);
    };
  }, [isOpen]);

  return (
    <Wrapper isOpen={isOpen} ref={dropdown}>
      <Content>
        <Link href={formatSearchUrl(state, city, undefined) + "?_start=0"}>
          <Callout textColor={colors.white}>{city}</Callout>
        </Link>

        <ImageContainer onClick={toggleState}>
          <NextImageWrapper>
            <NextImage width={12} height={7} src="/images/Home/arrow-down.svg" />
          </NextImageWrapper>
        </ImageContainer>
      </Content>

      <ListWrapper>
        {areas.map((area, idx) => (
          <Link key={area} href={formatSearchUrl(state, city, area) + "?_start=0"}>
            <ListItem>
              <Action textColor={colors.white}>{area}</Action>
            </ListItem>
          </Link>
        ))}
      </ListWrapper>
    </Wrapper>
  );
};

export default DropdownAnimated;
